import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class OnSiteInductionProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'onSiteInduction'}
            title={'PROCEDURE P17.0 ON-SITE INDUCTION'}
            exportTitle={'<h2>Procedure P17.0 On-site Induction</h2>'}
            exportFileName={'on_site_induction.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (OnSiteInductionProcedure);
